export const QUICK_NAV_DEFAULTS = [
	{
		key: 'all-news',
		adminLabel: 'All news',
		label: 'सर्व बातम्या',
		href: '/all-news',
	},
	{
		key: 'latest',
		adminLabel: 'Latest',
		label: 'ताज्या',
		href: '/latest-news',
	},
	{
		key: 'trending',
		adminLabel: 'Trending',
		label: 'ट्रेंडिंग',
		href: '/trending',
	},
	{
		key: 'selective',
		adminLabel: 'Selective',
		label: 'निवडक',
		href: '/recommended',
	},
	{
		key: 'most-read',
		adminLabel: 'Most read',
		label: 'सर्वाधिक वाचलेले',
		href: '/most-read',
	},
	{
		key: 'by-city',
		adminLabel: 'By city',
		label: 'शहरानुसार',
		href: '/city-wise-news',
		match: ['/city-wise-news', '/city'],
	},
]

export const QUICK_LINKS = QUICK_NAV_DEFAULTS.map(({ label, href, match }) => ({
	label,
	href,
	...(match ? { match } : {}),
}))
